export const STATUS_SALES_ORDER_APPROVE = {
  COMPLETE: 'Completado',
  IN_PROGRESS: 'En proceso',
}

export const COLOR_STATUS_SALES_ORDER_APPROVE = {
  COMPLETE: '#89E8CF',
  IN_PROGRESS: '#FFEE91',
  DEFAULT: '#FF96A0',
}
